import React from "react";

import { checkTranslation, imageAddress, sizeConvertor, translate } from "../../utils/useful";
import moment from 'jalali-moment'
import CircularProgress from "../useful/CircularProgress";
import MessageImageBox from "../views/messenger/boxes/MessageImageBox";
import MessageStatusView from "../views/messenger/boxes/MessageStatusView";
import MessageTextBox from "../views/messenger/boxes/MessageTextBox";
import MessageVideoBox from "../views/messenger/boxes/MessageVideoBox";
import MessageAudioBox from "../views/messenger/boxes/MessageAudioBox";
import MessageFileBox from "../views/messenger/boxes/MessageFileBox";
import MessageSystemInfo from "../views/messenger/boxes/MessageSystemInfo";
import { getBoundingClientRect } from "../../utils/functions";
import Modal from "../Modal";
import FixedView from "../FixedView";
import ButtonAnimated from "../buttons/ButtonAnimated";


class MessageBox extends React.Component {

    state = {
        show: false,
        showContextMenu: false,
        xPos: "0",
        yPos: "0",
        MessengerContextMenu: [
            { icon: "/assets/icons/messenger/reply.svg", title: "{{lang}}messenger.Reply", key: 'reply', color: "#444" },
            { icon: "/assets/icons/messenger/copy.svg", title: "{{lang}}messenger.Copy", key: 'copy', color: "#444" },
            { icon: "/assets/icons/messenger/edit.svg", title: "{{lang}}messenger.Edit", key: 'edit', color: "#444" },
            { icon: "/assets/icons/messenger/pin.svg", title: "{{lang}}messenger.Pin", key: 'pin', color: "#444" },
            { icon: "/assets/icons/messenger/forward.svg", title: "{{lang}}messenger.Forward", key: 'forward', color: "#444" },
            { icon: "/assets/icons/messenger/select.svg", title: "{{lang}}messenger.Select", key: 'select', color: "#444" },
            { icon: "/assets/icons/messenger/trash.svg", title: "{{lang}}messenger.Delete", key: 'delete', color: "#FF3B30" },
        ],
    }

    componentDidMount() {
        // let options = {
        //     root: document.querySelector('#messenger'),
        //     rootMargin: '0px 0px -50px 0px',
        //     threshold: 0.9
        // }
        // setTimeout(() => {
        let data = this.props.data

        if (this.props.isApplet) {
            // if (this.props.applet?.settings) {
            // }
        }

        // console.log(data)


        this.props.observer?.observe(this.messageContainer)
        setTimeout(() => {

            let messageBox = getBoundingClientRect(this.messageContainer)
            let messengerBox = getBoundingClientRect(document.querySelector('#messenger-' + this.props.messengerId))
            // console.log('messengerBox', messengerBox)
            // console.log('messageBox', messageBox)
            // console.log('msg', this.props.data)
            // if (messageBox.top >= messengerBox.top && messageBox.bottom >= messengerBox.bottom) {
            if ((messageBox.top <= (messengerBox.bottom - 30) && messageBox.top >= messengerBox.top) || (messageBox.bottom <= (messengerBox.bottom - 30) && messageBox.bottom >= messengerBox.top)) {
                // console.log('data', data)
                this.props.onViewableItemsChanged(data, true)
            }
        }, 40);
        // }, 500);
        // let observer = new IntersectionObserver(this.observerAction, options);
        // observer.observe(this.messageContainer);
        document.addEventListener('click', this.clickListener)
        this.container.addEventListener('scroll', this.scrollListener)

    }

    scrollListener = () => {
        if (this.state.showContextMenu) {
            this.setState({ showContextMenu: false })
        }
    }

    clickListener = () => {
        let contextMenu = this.state.contextMenu;
        if (contextMenu) {
            contextMenu.show = false;
            this.setState({
                showContextMenu: false,
                contextMenu: contextMenu
            })
        }
    }


    componentWillUnmount() {

        this.props.observer?.unobserve(this.messageContainer)
        document.removeEventListener('click', this.clickListener)
        this.container.removeEventListener('scroll', this.scrollListener)

    }




    onRightClickItem = (event, item, type) => {
        let currentItem = item;
        let corner = getBoundingClientRect(this.cornerDiv)

        this.setState({
            showContextMenu: true,
            contextMenu: {
                xPos: event.pageX - corner.left,
                yPos: event.pageY - corner.top,
                show: true,
                view: type
            },
            currentItem
        })
    }
    replyAction = (key, data) => {
        switch (key) {
            case 'delete': {
                this.deletemessage.showModal()

                break;
            }
            case 'edit': {
                let element = {}
                element.value = this.props.data.text
                this.props.updateInput(element)
                this.props.editMessageAction(this.props.data)
                this.props.setInputId(this.props.data._id)
                break;
            }

            case 'select': {
                this.props.selectMessage(data)

                break;
            }
            default:
                break;
        }
    }
    // observerAction = (entries) => {
    //     console.log('observerAction', entries)
    //     if (entries && entries[0]) {
    //         let top = false
    //         if (entries[0].intersectionRect && entries[0].intersectionRect.top < 10) {
    //             top = true
    //         }
    //         this.props.onViewableItemsChanged(this.props.data, entries[0].isIntersecting, top)
    //     }
    // }
    deleteMessageAction = (key) => {
        // console.log('00000000', this.props.data)
        if (key == 'all') {
            this.props.deleteMessage(this.props.data._id, this.props.messenger, this.props.myId, key, () => {
                // console.log('done-----')
                this.deletemessage.hideModal()
            })
        }
        else {
            this.props.deleteMessage(this.props.data._id, this.props.messenger, this.props.myId, key, () => {
                this.deletemessage.hideModal()
            })
        }
    }
    selectMessage = () => {
        console.log('showSelect', this.props.showSelect)
        if (this.props.showSelect) {
            this.props.selectMessage(this.props.data)
        }
    }
    hideModal = () => {
        this.deletemessage.hideModal()
    }
    render() {
        let prop = this.props.data
        let myFrame = this.props.myActiveRef?.frame
        myFrame = myFrame?._id ?? myFrame

        let isOther = true
        let isOtherRef = true
        let senderIsMe = false
        let showSenderInfo = false
        let showSelfSenderInfo = false

        let senderHub = prop.senderHub?._id ?? prop.senderHub
        let sender = prop.sender?._id ?? prop.sender

        if (myFrame) {

            if (myFrame == (prop.senderFrame?._id ?? prop.senderFrame)) {
                isOtherRef = false
            }

        }

        if (this.props.messenger?.type == 'support') {

            if (prop.isAdmin) {
                if (this.props.adminView) {
                    isOtherRef = false
                } else {
                    isOtherRef = true
                }
            } else {
                if (this.props.adminView) {
                    isOtherRef = true
                } else {
                    isOtherRef = false
                }
            }


        }



        if (sender == this.props.myId) {
            isOther = false
        }

        if (this.props.myId == sender) {
            senderIsMe = true
        }

        if ((isOtherRef && (this.props.messenger?.type == 'group')) || (isOtherRef && this.props.messenger?.type == 'support')) {
            showSenderInfo = true
            showSelfSenderInfo = true
        }

        if (!isOtherRef) {
            showSelfSenderInfo = true
        }

        if (sender == senderHub) {
            showSelfSenderInfo = false
        }


        // console.log(isOtherRef, this.props.messenger?.type)




        let name = this.props?.messenger?.visitor?.fullname
        let time = moment(prop?.cDate).format('HH:mm')
        if (!isOther) {
            name = 'Operator'
        }

        return (
            <div style={{ marginTop: "5px", background: this.props.selectList.includes(this.props.data._id) ? ' #F4F9FF ' : '#fff', paddingRight: this.props.selectList.includes(this.props.data._id) ? ' 20px ' : ' ', paddingLeft: this.props.selectList.includes(this.props.data._id) ? ' 20px ' : ' ' }} id={'msg-' + this.props.data?._id} ref={el => this.messageContainer = el} className={"messageBox position-relative w-100 d-flex br-10 transition " + (this.props.data.systemInfo ? 'justify-content-center' : isOther ? '' : 'justify-content-end')} key={prop._id} onClick={() => this.selectMessage()}>
                <div className="d-flex flex-column w-100">
                    <div className="flexc w-100 " style={{ justifyContent: isOtherRef ? 'flex-start' : 'flex-end' }}>
                        {isOtherRef && this.props.showSelect && (
                            // <div
                            // // onClick={() => this.selectMessage(this.props.data)}
                            // >
                            <div className='mrd-3'>
                                {this.props.selectList.includes(this.props.data._id) ? (
                                    <img className='flexcc' width={20} height={20} src='/assets/icons/messenger/check-fill.svg' />
                                ) : (
                                    <img className='flexcc' width={20} height={20} src='/assets/icons/messenger/check.svg' />
                                )}
                            </div>
                            // </div>
                        )}
                        <div className='d-flex py-2 w-100' >
                            <div className="d-flex" style={{}}>
                                {(isOtherRef && this.props.chatUsers && prop.type != 'system') && (
                                    <div className="mrd-3 d-flex" style={{ alignItems: "flex-end", marginBottom: "17px" }}>
                                        {this.props.messenger?.type == 'group' && (
                                            <img className="br-50 flexcc" width={30} height={30} style={{ objectFit: "cover" }} src={imageAddress(this.props.chatUsers[prop.senderHub]?.hub.image, 'profile')} />
                                        )}
                                    </div>
                                )}
                            </div>

                            <div ref={el => this.container = el} className='w-100 h-100 d-flex flex-column scroll-no-scrollbar'>
                                {/* {this.props.chatUsers && prop.sender && (
                                    <div className="d-flex w-100">
                                        <p className="font-size-10 mb-1 main-cb ">{this.props.messenger.type == 'group' ? prop.sender == this.props.myId ? '' : this.props.chatUsers[prop.sender]?.hub.fullname : ''}</p>
                                    </div>
                                )} */}

                                <div ref={el => this.cornerDiv = el} style={{ position: 'fixed', top: 0, left: 0, width: 1, height: 1 }}></div>
                                <div className='w-100' onContextMenu={(event) => { event.stopPropagation(); event.preventDefault(); this.onRightClickItem(event) }}>
                                    {/* {console.log('prop is ', prop)} */}
                                    {!prop.trashed || prop.trashed == false ? (
                                        <>
                                            {(prop.file || prop.key == 'file') && (
                                                <MessageFileBox data={prop} isOther={isOther} isOtherRef={isOtherRef} senderIsMe={senderIsMe} time={time} colors={this.props.colors} chatUsers={this.props.chatUsers} chatInteractive={this.props.chatInteractive} showSenderInfo={showSenderInfo} showSelfSenderInfo={showSelfSenderInfo} />
                                            )}

                                            {(prop.image || prop.key == 'image') && (
                                                <MessageImageBox openImageModal={this.props.openImageModal} data={prop} isOther={isOther} isOtherRef={isOtherRef} senderIsMe={senderIsMe} time={time} colors={this.props.colors} chatUsers={this.props.chatUsers} chatInteractive={this.props.chatInteractive} showSenderInfo={showSenderInfo} showSelfSenderInfo={showSelfSenderInfo} />
                                            )}

                                            {(prop.video || prop.key == 'video') && (
                                                <MessageVideoBox data={prop} isOther={isOther} isOtherRef={isOtherRef} senderIsMe={senderIsMe} time={time} colors={this.props.colors} chatUsers={this.props.chatUsers} chatInteractive={this.props.chatInteractive} showSenderInfo={showSenderInfo} showSelfSenderInfo={showSelfSenderInfo} />
                                            )}

                                            {(prop.voice || prop.key == 'voice') && (
                                                <MessageAudioBox data={prop} isOther={isOther} isOtherRef={isOtherRef} senderIsMe={senderIsMe} time={time} colors={this.props.colors} chatUsers={this.props.chatUsers} chatInteractive={this.props.chatInteractive} showSenderInfo={showSenderInfo} showSelfSenderInfo={showSelfSenderInfo} />
                                            )}


                                            {(prop.text && !prop.file && !prop.image) && (
                                                <MessageTextBox data={prop} isOther={isOther} isOtherRef={isOtherRef} senderIsMe={senderIsMe} time={time} colors={this.props.colors} chatUsers={this.props.chatUsers} chatInteractive={this.props.chatInteractive} messenger={this.props.messenger} showSenderInfo={showSenderInfo} showSelfSenderInfo={showSelfSenderInfo} />
                                            )}
                                            {prop.systemInfo && (
                                                <MessageSystemInfo data={prop} isOther={isOther} isOtherRef={isOtherRef} senderIsMe={senderIsMe} time={time} colors={this.props.colors} />
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <div className="">
                                                <p className="weight-300" style={{ color: "#777", fontSize: 12, }}>{translate('messenger.This message has been deleted')}</p>
                                            </div>
                                            <div className={"w-100 d-flex mt-1 " + (isOther ? 'justify-content-start align-items-start' : 'justify-content-end align-items-end')}>
                                                <div className="flexc">
                                                    <p className='mrd-2' style={{ color: "gray", fontSize: 10 }}>{time}</p>
                                                    {!isOther && (
                                                        <MessageStatusView status={prop.status} colors={this.props.colors} />
                                                    )}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        {!isOther && this.props.showSelect && (
                            // <div
                            // // onClick={() => this.props.selectMessage(this.props.data)}
                            // >
                            <div className='mld-3'>
                                {this.props.selectList.includes(this.props.data._id) ? (
                                    <img className='flexcc' width={20} height={20} src='/assets/icons/messenger/check-fill.svg' />
                                ) : (
                                    <img className='flexcc' width={20} height={20} src='/assets/icons/messenger/check.svg' />
                                )}
                            </div>
                            // </div>
                        )}
                    </div>
                    {this.state.showContextMenu && (
                        <div style={{ position: "fixed", top: this.state.contextMenu.yPos, left: this.state.contextMenu.xPos, zIndex: "100000" }}>
                            <div className='shadow-2 px-2 py-1 br-10' style={{ width: "150px", backgroundColor: "#fff", }}>
                                {this.state.MessengerContextMenu.map((prop, index) => {
                                    return (
                                        <div className="bb-gray">
                                            <button className='flexcb w-100 py-1 my-1 hover-gray2 br-5 px-2' onClick={() => this.replyAction(prop.key, this.props.data)}>
                                                <p style={{ color: prop.color }}>{checkTranslation(prop.title)}</p>
                                                <img width={22} src={prop.icon} />
                                            </button>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )}
                    <Modal className="" ref={el => this.deletemessage = el} maxWidth={350} style={{}}>
                        <div className='flexc p-4 br-8 flex-column w-100' style={{ backgroundColor: "#fff" }}>
                            <p className='font-size-16 main-c2 weight-500' style={{}}>{translate('messenger.Delete Message?')}</p>
                            <p className='font-size-12 main-c7 mt-2' style={{}}>{translate('messenger.Are you sure you want to delete the message?')}</p>
                            <div className="flexc w-100 pt-4" style={{ justifyContent: 'flex-end' }}>
                                <div className="flexc mrd-2">
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={() => this.deleteMessageAction('me')}
                                        title={translate('messenger.Delete for me')}
                                        icon='/assets/icons/angle-right-white2.svg'
                                        textColor={'#fff'}
                                        bg={`linear-gradient(90deg, #ef0b0bdd, #ef0b0bdd)`}
                                    />
                                </div>
                                <div className="flexc mld-2">
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={() => this.deleteMessageAction('all')}
                                        title={translate('messenger.Delete for all')}
                                        icon='/assets/icons/angle-right-white2.svg'
                                        textColor={'#fff'}
                                        bg={`linear-gradient(90deg, #ef0b0bdd, #ef0b0bdd)`}
                                    />
                                </div>
                            </div>
                            <div className="flexc pt-2 w-100">
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => { this.hideModal() }}
                                    title={translate('messenger.Cancel')}
                                    textColor={'#a3a2b0'}
                                    bg={'#eee'}
                                />
                            </div>
                            {/* <div className='mt-4 flexc w-100'>
                                <button className='px-3 py-2 br-5 mrd-3 cancel-btn2 w-100' onClick={() => this.deleteMessageAction('me')}>
                                    <p className='font-size-14 white'>{translate('messenger.Delete For Me')}</p>
                                </button>
                                <button className='px-3 py-2 br-5 mld-3 cancel-btn2 w-100' onClick={() => this.deleteMessageAction('all')}>
                                    <p className='font-size-14 white'>{translate('messenger.Delete For All')}</p>
                                </button>
                            </div>
                            <button className='px-3 py-2 br-5 mx-2 mt-3 w-100' style={{ backgroundColor: "#eee", width: "255px" }} onClick={() => this.hideModal()}>
                                <p className='font-size-14 main-c5'>{translate('messenger.Cancel')}</p>
                            </button> */}
                        </div>
                    </Modal>
                    {prop.form && Object.values(prop.form).map((fprop, findex) => {
                        return (
                            <p key={findex} className="chatbox-desc" >{checkTranslation(fprop.label)}: {checkTranslation(fprop.value)}</p>
                        )
                    })}
                </div>
            </div >
        )
    }

}


export default MessageBox
